function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import React from "react";
import PropTypes from "prop-types";
import useTheme from "../../hooks/useTheme";
import useBackground from "../../hooks/useBackground";
import useResponsivePropsCSS from "../../hooks/useResponsivePropsCSS";
import VisuallyHidden from "../VisuallyHidden";
import { jsx as ___EmotionJSX } from "@emotion/core";
var COLORS = ["grey.t05", "white"];
var DEFAULT_PROPS = {
  color: "grey.t05",
  disabled: false,
  __internal__keyboardFocus: false
};
InternalCheckbox.COLORS = COLORS;
InternalCheckbox.DEFAULT_PROPS = DEFAULT_PROPS;
function CheckboxIcon(_ref) {
  var _color = _ref.color,
    isChecked = _ref.isChecked;
  var theme = useTheme();
  var _useBackground = useBackground(),
    inputColorMap = _useBackground.inputColorMap;
  var rectCSS = useResponsivePropsCSS({}, {}, {
    color: function color(propsAtBreakpoint, theme, bp) {
      return theme.checkbox.getCSS({
        targetElement: "svgRect",
        color: _color !== null && _color !== void 0 ? _color : inputColorMap[bp],
        isChecked: isChecked
      });
    }
  });
  return ___EmotionJSX("svg", {
    css: theme.checkbox.getCSS({
      targetElement: "svg"
    }),
    viewBox: "0 0 100 100",
    focusable: "false",
    "aria-hidden": "true"
  }, ___EmotionJSX("rect", {
    css: rectCSS,
    width: "100",
    height: "100",
    rx: "16"
  }), isChecked && ___EmotionJSX("path", {
    css: theme.checkbox.getCSS({
      targetElement: "svgPath"
    }),
    d: "M21 51 l22 18 l35 -39",
    fill: "transparent",
    strokeWidth: "14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
CheckboxIcon.propTypes = {
  color: PropTypes.oneOf(COLORS),
  isChecked: PropTypes.bool.isRequired
};
function InternalCheckbox(_props) {
  var props = _objectSpread(_objectSpread({}, DEFAULT_PROPS), _props);
  var name = props.name,
    parentName = props.parentName,
    inputId = props.inputId,
    color = props.color,
    disabled = props.disabled,
    isValid = props.isValid,
    labelledBy = props.labelledBy,
    describedBy = props.describedBy,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    value = props.value,
    onChange = props.onChange,
    onMouseDown = props.onMouseDown,
    children = props.children,
    __internal__keyboardFocus = props.__internal__keyboardFocus;
  var theme = useTheme();
  var _useBackground2 = useBackground(),
    inputColorMap = _useBackground2.inputColorMap;
  var labelCSS = useResponsivePropsCSS(props, DEFAULT_PROPS, {
    color: function color(propsAtBreakpoint, theme, bp) {
      var _props$color;
      return theme.checkbox.getCSS({
        targetElement: "label",
        color: (_props$color = _props.color) !== null && _props$color !== void 0 ? _props$color : inputColorMap[bp],
        __internal__keyboardFocus: __internal__keyboardFocus
      });
    }
  });
  return ___EmotionJSX("div", {
    css: theme.checkbox.getCSS({
      targetElement: "container"
    }),
    role: "checkbox",
    "aria-invalid": isValid ? null : "true",
    "aria-checked": value,
    "aria-labelledby": labelledBy,
    "aria-describedby": describedBy
  }, ___EmotionJSX(VisuallyHidden, null, ___EmotionJSX("input", {
    css: theme.checkbox.getCSS({
      targetElement: "input"
    }),
    type: "checkbox",
    id: inputId,
    name: name,
    "data-parent-name": parentName,
    checked: value,
    disabled: disabled,
    onFocus: onFocus,
    onBlur: onBlur,
    onChange: onChange
  })), ___EmotionJSX("label", {
    css: labelCSS,
    htmlFor: inputId,
    onMouseDown: onMouseDown
  }, ___EmotionJSX(CheckboxIcon, {
    color: color,
    isChecked: value
  }), ___EmotionJSX("span", null, children)));
}
InternalCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  parentName: PropTypes.string,
  inputId: PropTypes.string.isRequired,
  color: PropTypes.oneOf(COLORS),
  disabled: PropTypes.bool,
  isValid: PropTypes.bool.isRequired,
  labelledBy: PropTypes.string,
  describedBy: PropTypes.string,
  onFocus: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onMouseDown: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  __internal__keyboardFocus: PropTypes.bool
};
export default InternalCheckbox;